import React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Icon, Text } from '../../../../../../components';
import { BackButton, ToggleCard } from '../../../../components';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import Spinner from '../../../../../../components/Spinner';
import Step from '../Register/components/Step';
import StatusRequest from '../../../../components/Cards/request/Status';
import Processing from '@/presentation/components/Processing';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { List } from '@/presentation/reusables/components/List';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';

const UpdatePhotoProgressView = (props: any) => {
  const {
    isLoading,
    isLoadingCancel,
    isComplete,
    request,
    procedure,
    handleBack
  } = props;
  const isCreatedOrActived = ['PENDIENTE'].includes(request?.status?.status);

  return (
    <div data-testid="cmp-update_photo_progress_view">
      <ContainerProcedure>
        {isLoading && <Spinner />}
        {request && !isLoading && (
          <SubContainer>
            <Block customized justifyContent="flex-start" margin="0px 0px 16px">
              <BackButton onClick={handleBack} />
            </Block>
            <ToggleCard>
              {/* {toggleTitle} */}
              <Text
                color="#161D1F"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="900"
              >
                {procedure?.name}
              </Text>
              <Block
                customized
                style={{ width: '100%' }}
                margin="0px 0px 8px 0px"
              >
                <StatusRequest {...request.status} />
                <Block
                  customized
                  flexDirection="row"
                  alignItems="center"
                  margin="8px 0px 0px 0px"
                >
                  <Icon
                    customized
                    maxWidth="16.9px"
                    height="15px"
                    margin="0px 4.67px 0px 0px"
                  >
                    <img src={moneyIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="14px"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    {procedure?.amount}
                  </Text>
                  <Icon
                    customized
                    maxWidth="1px"
                    height="13px"
                    margin="0px 0px 0px 16px"
                  >
                    <img src={lineIcon} alt="other" />
                  </Icon>
                  <Icon
                    customized
                    maxWidth="13.33px"
                    margin="0px 5.33px 0px 17.33px"
                  >
                    <img src={clockIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="12px"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    {procedure?.duration || ''}
                  </Text>
                </Block>
              </Block>
              <List />
            </ToggleCard>
            {/* Progreso */}
            <Heading
              text="Progreso"
              level={2}
              color="var(--text-text02)"
              size={18}
              lineHeight={28}
              fontWeight="900"
              className=""
              align="flex-start"
            />
            <Block
              customized
              padding={isMobile ? '20px 0px 0px 8px' : '20px 0px 0px 16px'}
            >
              <Step
                isFirst
                // name={procedure.steps[0].name}
                name="Registrar solicitud"
                order={procedure.steps[0].order}
                date={procedure.steps[0].date?.toLowerCase()}
                isComplete={1}
                isCurrent={procedure.steps[0].isCurrent}
              >
                <Text />
              </Step>
              <Step
                name={procedure.steps[1].name}
                order={procedure.steps[1].order}
                // date={procedure.steps[1].date}
                isComplete={procedure.steps[1].isComplete || isComplete}
                isCurrent={procedure.steps[1].isCurrent}
                isLast
              >
                <Text fontSize="12px" style={{ margin: '-12px 0px 0px 0px' }}>
                  {isCreatedOrActived
                    ? ''
                    : procedure.steps[1].date?.toLowerCase()}
                </Text>
                <CardProgress
                  title={`Tu solicitud ha sido aprobada`}
                  subtitle="Tu foto fue registrada con éxito y actualizada."
                  image={[documentSuccessImage, documentSuccessDskImage]}
                />
              </Step>
            </Block>
          </SubContainer>
        )}

        <Processing isOpen={isLoadingCancel} />
      </ContainerProcedure>
    </div>
  );
};

export default UpdatePhotoProgressView;
